<template>
  <div class="table_box">
    <div class="table_head">
      <div class="head_name">商品</div>
      <div class="pub_flex">买家</div>
      <div class="pub_flex">实付款</div>
      <div class="head_address">收货人</div>
      <div class="pub_flex">状态</div>
    </div>
    <div v-if="order_list.records.length != 0">
      <div
        class="table_content"
        v-for="item in order_list.records"
        :key="item.id"
      >
        <div class="table_title">
          <div>
            <span>订单号:</span>
            <span>{{ item.orderCode }}</span>
          </div>
          <div style="flex: 1; margin-left: 30px">
            <span>下单时间:</span>
            <span>{{
              $api.moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </div>
          <div style="cursor: pointer" @click="memo_click(item)">
            <i :class="['el-icon-wind-power',item.memo?'color_red':'']"></i> 备注
          </div>
        </div>
        <div class="table_item">
          <div class="goods_name pub_border">
            <div class="goods_box">
              <div>
                <el-image
                  :z-index="99999"
                  style="width: 100px; height: 100px"
                  :src="item.imgurl"
                  :preview-src-list="item.imgurl ? src_list(item.imgurl) : []"
                >
                </el-image>
              </div>
              <div class="goods_spec">
                <div
                  class="goods_wrap"
                  style="font-size: 14px; color: #535a6c; padding-bottom: 6px"
                >
                  {{ item.goodsName }}
                </div>
                <div class="goods_wrap">SKU编码:{{ item.skuCode }}</div>
                <div class="goods_wrap">{{ item.skuName }}</div>
              </div>
              <div>
                <div>¥ {{ $api.returnFloat(item.costPrice) }}</div>
                <div>x{{ item.quantity }}</div>
              </div>
            </div>
          </div>
          <div class="buyer_name pub_border">{{ item.buyerNickName }}</div>
          <div class="buyer_price pub_border">
            ¥ {{ $api.returnFloat(item.costTotalFee) }}
          </div>
          <div class="buy_address pub_border">
            <div>{{ item.receiverName + item.receiverMobile }}</div>
            <div>{{ item.receiverAddress }}</div>
          </div>
          <div class="order_detail pub_border">
            <div>{{ $parent.status_packing(item.status) }}</div>
            <div
              style="color: #409eff; cursor: pointer"
              @click="to_order_detail(item.id)"
            >
              查看详情
            </div>
            <div
              v-if="
                item.status == 'WAIT_SEND_GOODS' ||
                item.status == 'PART_SEND_GOODS'
              "
            >
              <el-button size="small" type="success" @click="send_sub(item.id)"
                >发货</el-button
              >
            </div>
            <div v-if="item.status == 'WAIT_ORDER_RECEIVING'">
              <el-button size="small" type="primary" @click="recevie(item.id)"
                >接单</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
    <el-dialog title="添加备注" :visible.sync="dialogVisible" width="30%">
      <el-input
        v-model="memo"
        type="textarea"
        placeholder="请输入备注内容"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="memo_btn">确 定</el-button>
      </span>
    </el-dialog>
    <sendGoods
      @changeshow="change"
      :orderType="orderType"
      :dialogShow="dialogShow"
      :orderId="orderId"
    ></sendGoods>
  </div>
</template>
<script>
import { recevie_order, order_memo } from "@/request/api/order";
import sendGoods from "./sendGoods.vue";
let _this;
export default {
  props: ["order_list"],
  components: {
    sendGoods,
  },
  data() {
    return {
      memo: "",
      dialogVisible: false,
      dialogShow: false,
      orderId: "",
      orderType: "general",
    };
  },
  created() {
    _this = this;
  },
  methods: {
    memo_click(e) {
      _this.dialogVisible = true;
      _this.orderId = e.id;
      _this.memo = e.memo;
    },
    memo_btn() {
      console.log(_this.$parent.page_order_data)
      if(!_this.memo){
        _this.$api.e_msg('备注不能为空哦');
        return
      }
      order_memo({
        id: _this.orderId,
        memo: _this.memo,
      }).then((res) => {
        if (res.code == 0) {
          _this.$api.s_msg(res.msg);
          _this.$parent.$refs.status_bar.get_order(_this.$parent.page_order_data)
          _this.dialogVisible = false;
        } else {
          _this.$api.e_msg(res.msg);
        }
      });
    },
    change(e) {
      console.log(e);
      _this.dialogShow = e;
    },
    send_sub(e) {
      console.log(e);
      _this.orderId = e;
      _this.dialogShow = true;
    },
    recevie(e) {
      _this
        .$confirm("确认接单吗？")
        .then(() => {
          console.log(e);
          recevie_order(e).then((res) => {
            if (res.code == 0) {
              _this.$api.s_msg(res.msg);
              _this.$parent.$refs.status_bar.get_order(
                this.$parent.page_order_data
              );
            } else {
              _this.$api.e_msg(res.msg);
            }
            console.log(res);
          });
        })
        .catch(() => {
          console.log("取消");
        });

      // return
    },
    //   图片预览
    src_list(e) {
      return e.split(",");
    },
    to_order_detail(e) {
      _this.$router.push({
        name:'orderDetail',
        params: {
          id: e,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.color_red{
  color: red;
}
.table_box {
  height: 85%;
  overflow: hidden;
  overflow-y: scroll;
  width: 100%;
  color: #434344;
  font-size: 15px;
  .table_head {
    width: 100%;
    display: flex;
    background-color: #ebecf0;
    text-align: center;
    padding: 3px 0;
    margin-bottom: 5px;
    .pub_flex {
      flex: 1;
    }
    .head_name {
      flex: 2;
    }
    .head_address {
      flex: 2;
    }
  }
  .table_content {
    border-bottom: 1px solid #ebecf0;
    font-size: 14px;
    .table_title {
      display: flex;
      justify-content: space-between;
      border: 1px solid #ebecf0;
      padding: 2px 20px;
      background-color: #ebecf0;
    }
    .table_item {
      height: 160px;
      display: flex;
      text-align: center;
      border-left: 1px solid #ebecf0;
      align-items: center;
      color: #535a6c;
      .pub_border {
        height: 100%;
        border-right: 1px solid #ebecf0;
        // padding: 20px 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      .goods_name {
        flex: 2;
        .goods_box {
          box-sizing: border-box;
          display: flex;
          align-items: center;
          padding: 0 20px;
          .goods_spec {
            color: #909090;
            font-size: 12px;
            flex: 1;
            align-self: flex-start;
            text-align: left;
            padding: 0 16px;
            max-width: 168px;
            .goods_wrap {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }

      .buyer_name {
        flex: 1;
      }
      .buyer_price {
        flex: 1;
      }
      .buy_address {
        flex: 2;
      }
      .order_detail {
        flex: 1;
      }
    }
  }
}
</style>